import Store from '@copilot/common/store';

export default Store;
